import { format } from 'date-fns'

export const dateFilters = {
  formatDate: v => v ? format(new Date(v), 'dd/MM/yyyy') : '',
  formatDateTime: v => v ? format(new Date(v), 'dd/MM/yyyy HH:mm:ss') : ''
}
